import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-12 sm:py-16" data-id="element-160" data-mp="20m4qnvskykwl">
      <div className="mx-auto max-w-2xl rounded-3xl border border-forest-mid/25 bg-cream p-6 text-center sm:p-9" data-id="element-161" data-mp="24molgspolcfk">
        <ShieldCheckIcon className="mx-auto h-12 w-12 text-forest-mid" aria-hidden="true" data-id="element-162" data-mp="29eyl50gllqv1" />
        <p className="mt-3 text-[11px] font-extrabold uppercase tracking-[0.2em] text-forest" data-id="element-163" data-mp="2edt1zwv095ci">
          Your purchase is protected
        </p>
        <h2 className="mt-2 font-display text-[26px] font-black leading-tight text-navy-deep sm:text-4xl" data-id="element-164" data-mp="2ja9s2wlrlts8">
          7-Day Satisfaction Guarantee
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-[15px] font-medium leading-relaxed text-ink/70" data-id="element-165" data-mp="2sd2eomk05hbq">
          We want you to be confident in your decision. That’s why you can review the Clinical Kit for
          7 days. If you don’t feel that the Kit helps you make faster clinical decisions, adds
          meaningful value to your practice, or simply isn’t what you expected, contact us and we’ll
          refund 100% of your purchase.
        </p>
        <p className="mt-4 font-display text-lg font-bold text-navy-deep" data-id="element-166" data-mp="3nsn8l326cmrl">
          No questions. No complications. No risk.
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-167" data-mp="3dx26z610poid">
          <CTAButton label="Try it risk-free today" sub="7-Day Guarantee · 100% Money-Back Guarantee" data-id="element-168" data-mp="3dyd9l2iq8q7w" />
        </div>
      </div>
    </section>;
}